import { render, staticRenderFns } from "./ChampionshipNationalChampionship.vue?vue&type=template&id=478fd868&scoped=true&"
import script from "./ChampionshipNationalChampionship.vue?vue&type=script&lang=js&"
export * from "./ChampionshipNationalChampionship.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipNationalChampionship.vue?vue&type=style&index=0&id=478fd868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478fd868",
  null
  
)

export default component.exports